import { Spin } from 'antd';
import React, { useEffect, useState, useCallback } from 'react';
import { addCalendlyScript, addCalendlyCSSFile, removeCalendlyScript, removeCalendlyCSSFile } from '../../components/public/scheduleCalendly/calendlyGeneralFunction';
import PropTypes from 'prop-types';
import { STATUS } from '../../constants/status';
import roundCheck from '../../../assets/img/round-check_circle-24px.svg';

function VetsmithCalendly ({ name, email, event, onScheduled, eventLink, status }) {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    addCalendlyCSSFile('Vetsmith')
      .then(() => addCalendlyScript('Vetsmith'))
      .then(() => setLoaded(true));
    function isCalendlyEvent (e) {
      return e.data.event && e.data.event.indexOf('calendly') === 0;
    };
    const onEvent = (e) => {
      if (isCalendlyEvent(e)) {
        if (onScheduled && e.data.event === 'calendly.event_scheduled') onScheduled(e.data.payload.event.uri);
      }
    };
    window.addEventListener('message', onEvent);
    return () => {
      removeCalendlyScript('Vetsmith');
      removeCalendlyCSSFile('Vetsmith');
      window.removeEventListener('message', onEvent);
      if (window.Calendly) window.Calendly.closePopupWidget();
      document.body.style.overflow = 'auto';
    };
  }, []);

  const show = useCallback(() => {
    window.Calendly.initPopupWidget({
      url: eventLink,
      prefill: { name, email }
    });
  }, [name, email, loaded]);

  if (event && status === STATUS.PASSED_TI) {
    return (
      <span className="Vetsmith-item-status Vetsmith-item-status-passed">
        <img
          src={roundCheck}
          style={{
            width: 18,
            height: 18,
            background: `transparent url(${roundCheck}) 0% 0% no-repeat padding-box !important`,
            opacity: 1
          }}
          alt="check"
        /> Passed</span>
    );
  }

  if (event) {
    return <span className="Vetsmith-scheduled"><span className="material-icons">today</span> Scheduled</span>;
  }
  return (
    <Spin spinning={!loaded}>
      <button className="Vetsmith-start-btn" onClick={show}><span className="material-icons">today</span> Schedule Interview</button>
    </Spin>
  );
}

VetsmithCalendly.propTypes = {
  name: PropTypes.any,
  email: PropTypes.any,
  event: PropTypes.any,
  eventLink: PropTypes.any,
  status: PropTypes.any,
  onScheduled: PropTypes.func
};

export default VetsmithCalendly;
